import React, { Component } from "react";
import "./index.css";
import SubtitlesOctopus from 'libass-wasm';
// import "./subtitles.js";
// import worker from "./libass/js/subtitles-octopus-worker.js";
// import WorkerLegacy from "./libass/js/subtitles-octopus-worker-legacy.js";
// import subs from "./sub.ass";

class Test extends Component {
  componentDidMount() {
    this.sub()
  }
  
       sub = () => {
        var options = {
          video: document.querySelector('video'), // HTML5 video element
          subUrl: 'https://download1593.mediafire.com/palvse8qe7vg/a47kklnkrpr9v0j/sub.ass', // Link to subtitles
          fonts: ['https://download948.mediafire.com/lbt817bk7ptg/2ctwcm8ivbjc1nn/font.ttf'], // Links to fonts (not required, default font already included in build)
          workerUrl: "https://keen-crisp-38f08a.netlify.app/node_modules/libass-wasm/dist/js/subtitles-octopus-worker.js" // Link to WebAssembly-based file "libassjs-worker.js"
        };
        var instance = new SubtitlesOctopus(options);
        instance.setTrackByUrl('https://download1593.mediafire.com/palvse8qe7vg/a47kklnkrpr9v0j/sub.ass');
       }

render() {
  return (
    <div className="container">
       <h1>test</h1>
       <video id="video" controls src="https://download1489.mediafire.com/cswrbhgwsz3g/r17wx6qjaiataew/Ep.mp4"></video>
       <button onClick={this.sub}>Subtitles</button>
    </div>
  )}
}

export default Test;